import React from 'react';
import emlaktv from './images/gridScreen.png';
import kurumsal from "./images/kurumsal.png"
import ilanekle from "./images/ilanekle.jpg"
import tvapp from "./images/Tvapp.png"
import yukle from "./images/yukle.jpg"

const steps = [
  {
    title: "Kurumsal Üyelik Oluştur",
    description: "emlakvitrini.net üzerinden yada EmlakApp mobil uygulamamız ile  öncelikle e-posta adresinizle üye olun. Ardından 'Ayarlarım' bölümüne girerek Kurumsala Geçiş Formu’nu doldurun. Formun ikinci adımında, sizden bir kullanıcı adı seçmeniz ve hangi cihazı kullanmak istediğiniz bilgisi istenir. Seçtiğiniz kullanıcı adı, online dükkânınızın adresini belirler. Örneğin, 'xemlak' ismini seçerseniz, dükkan adresiniz xemlak.emlakvitrini.net olacaktır. Eğer hâlihazırda bir Android TV’niz varsa, yalnızca abonelik siparişi vermeniz yeterlidir. Ödemeyi yaptıktan yaklaşık 1 dakika sonra online dükkânınız aktif hale gelir ve yayınlamaya başlar.",
     image:kurumsal
  },
  {
    title: "İlanlarınızı Ekleyin",
    description: "Web paneli üzerinden ilanlarınızı kolayca yönetebilirsiniz. Fotoğraflar, açıklamalar ve fiyat bilgilerini dakikalar içinde ekleyerek ilanınızı hazır hale getirin.'İlanı Kaydet' butonuna tıkladığınızda, ilanınız aynı anda hem televizyon vitrininizde, hem kişisel online dükkânınızda, hem de emlakvitrini.net adresinde eşzamanlı olarak yayınlanır.",
      image:ilanekle
  },
  {
    title: "TV Uygulamasını Yükleyin",
    description:"Android TV, Mi Box veya Android Receiver cihazınıza TvEmlakVitrini uygulamamızı yükleyin. Uygulamayı başlattığınızda açılan ekrana size verilen şirket ID’sini kumandanızla girin. Tüm ilanlarınız ekranda görüntülenir. İlanlarınızı ayarlarda belirlediğiniz düzende veya tek tek slayt şeklinde gösterebilirsiniz. Arka plan rengi ise seçiminize göre ayarlanır.",
    image:yukle
  },
  {
    title: "Ekranda Otomatik Yayın Başlasın",
    description: "Artık ilanlarınız ekranda dönmeye başlar! Slayt moduyla sürekli güncel ve etkileyici bir vitrin elde edin.",
    image:emlaktv
  }
];

const HowItWorks = () => {
  return (
    <div style={{ backgroundColor: '#f0f4f8', padding: '80px 20px' }}>
      <style>{`
        @media (max-width: 768px) {
          .step-block {
            grid-template-columns: 1fr !important;
            padding: 20px !important;
            gap: 20px !important;
          }

          .step-block h2 {
            font-size: 26px !important;
          }

          .step-block h3 {
            font-size: 20px !important;
          }

          .step-block p {
            font-size: 15px !important;
          }

          .step-block .step-number {
            font-size: 40px !important;
            text-align: center !important;
          }
        }
      `}</style>

      <h2 style={{
        textAlign: 'center',
        fontSize: '36px',
        marginBottom: '60px',
        color: '#333',
        fontWeight: '700'
      }}>
        Nasıl Çalışır?
      </h2>

      {steps.map((step, index) => {
        const isEven = index % 2 === 0;

        return (
          <div
            key={index}
            className="step-block"
            style={{
              backgroundColor: 'white',
              borderRadius: '16px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              padding: '40px',
              width: '90%',
              maxWidth: '1100px',
              margin: '40px auto',
              display: 'grid',
              gridTemplateColumns: isEven ? '2fr 2fr' : '2fr 2fr',
              gap: '40px',
              alignItems: 'center'
            }}
          >
            <div>
              <div className="step-number" style={{
                fontSize: '72px',
                fontWeight: '900',
                color: '#4F75FF',
                marginBottom: '10px'
              }}>
                {index + 1 < 10 ? `0${index + 1}` : index + 1}
              </div>
              <h3 style={{
                fontSize: '28px',
                color: '#333',
                fontWeight: '700',
                marginBottom: '12px'
              }}>
                {step.title}
              </h3>
              <p style={{
                fontSize: '18px',
                color: '#555',
                lineHeight: 1.7
              }}>
                {step.description}
              </p>
            </div>

            <img
              src={step.image}
              alt="Nasıl çalışır adımı"
              style={{
                width: '100%',
                borderRadius: '12px',
                objectFit: 'cover',
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default HowItWorks;
